module.exports = __webpack_public_path__ + "static/img/anxun21new.ef2e1227.png";